import { useContext } from 'react';
import * as R from 'ramda';

import ErrorSection from './ErrorSection';
import MoveElementModalContext from './MoveElementModalContext';

import classes from './moveElement.module.css';

const ErrorView = () => {
  const { element, elementErrors } = useContext(MoveElementModalContext);

  const assetErrors = R.pathOr(
    [],
    [element?.id, 'hasOtherAssets'],
    elementErrors,
  );

  const formErrors = R.pathOr(
    [],
    [element?.id, 'hasFormAssets'],
    elementErrors,
  );

  return (
    <div className={classes.errorView}>
      <div>
        <span className={classes.elementName}>{element?.name}</span>
        <span>cannot be moved or replaced for the following reasons:</span>
      </div>
      <ErrorSection
        errors={assetErrors}
        message="This sub item shares open work with other sub items and/or current parent."
      />
      <ErrorSection
        errors={formErrors}
        message="This sub item is on open work that contains a form that allows editing other sub-items and/or current parent."
      />
    </div>
  );
};

export default ErrorView;
